import { defineComponent, ref, onMounted } from 'vue';

import iphone from '../Images/screen.png';
import logo from '../Images/logo.mobile.truckdown.png';
import towing from '../Images/towing.png';
import tire from '../Images/tire.png';
import truckRepair from '../Images/truck-repair.png';
import truckStop from '../Images/truck-stop.png';


interface Service {
    name: string,
    icon: string
}

export default defineComponent({

    setup: function (props, ctx) {

        const services = ref<Service[]>([
            {
                name: "Road Service",
                icon: "road"
            },
            {
                name: "Truck Repair",
                icon: ""
            },
            {
                name: "Tire Repair",
                icon: ""
            },
            {
                name: "Towing Service",
                icon: ""
            },
            {
                name: "Truck Shops",
                icon: "truck-front"
            },
            {
                name: "Tire Shops",
                icon: ""
            },
            {
                name: "Trailer Shops",
                icon: "caravan"
            },
            {
                name: "Truck Stops & More",
                icon: ""
            },
            
        ]);
 

        return {
            services,
            iphone,
            logo,
            towing,
            tire,
            truckRepair,
            truckStop
        }
    }
});


